import Graphic from '@arcgis/core/Graphic';

// Triángulo del sample oficial "Arrows along a line" de ArcGIS: apunta en el
// sentido de avance de la línea (orden de los vértices) con angleToLine: true.
const ARROW_RINGS = [
  [
    [-8, -5.47],
    [-8, 5.6],
    [1.96, -0.03],
    [-8, -5.47]
  ]
];

/**
 * Crea un gráfico de flechas direccionales sobre una ruta.
 *
 * Usa un CIMSymbol con CIMMarkerPlacementAlongLineSameSize: las flechas se
 * espacian en puntos de pantalla (placementTemplate), por lo que la densidad
 * se adapta sola al zoom (muchas de cerca, pocas de lejos), y angleToLine
 * las orienta según el sentido de los vértices de la polilínea.
 *
 * @param {Array<Array<number>>} pathCoordinates - Vértices [longitud, latitud] en orden de avance
 * @param {string} routeType - 'original' | 'mapmatched' (para los switches de visibilidad)
 * @returns {Graphic} Gráfico de solo-flechas con la misma geometría de la ruta
 */
export function buildDirectionArrowsGraphic(pathCoordinates, routeType) {
  return new Graphic({
    geometry: {
      type: 'polyline',
      paths: [pathCoordinates],
      spatialReference: { wkid: 4326 }
    },
    symbol: {
      type: 'cim',
      data: {
        type: 'CIMSymbolReference',
        symbol: {
          type: 'CIMLineSymbol',
          symbolLayers: [
            {
              type: 'CIMVectorMarker',
              enable: true,
              size: 9,
              markerPlacement: {
                type: 'CIMMarkerPlacementAlongLineSameSize',
                endings: 'WithMarkers',
                placementTemplate: [200], // separación entre flechas en puntos de pantalla (~5x menos densas que antes)
                angleToLine: true
              },
              frame: { xmin: -5, ymin: -5, xmax: 5, ymax: 5 },
              markerGraphics: [
                {
                  type: 'CIMMarkerGraphic',
                  geometry: { rings: ARROW_RINGS },
                  symbol: {
                    type: 'CIMPolygonSymbol',
                    symbolLayers: [
                      {
                        // Contorno blanco para contraste sobre las líneas roja y verde
                        type: 'CIMSolidStroke',
                        enable: true,
                        width: 0.8,
                        color: [255, 255, 255, 230]
                      },
                      {
                        // Relleno celeste (estilo flespi)
                        type: 'CIMSolidFill',
                        enable: true,
                        color: [0, 188, 212, 255]
                      }
                    ]
                  }
                }
              ]
            }
          ]
        }
      }
    },
    attributes: {
      routeType: routeType,
      type: 'directionArrows'
    }
  });
}
